import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import {
  alertNotification,
} from '../shared/store/actions';

import {
  sharedActions,
} from './store/actions';

class GLAccountListAdminColumnRenderer extends PureComponent {
  static propTypes = {
    value: PropTypes.shape({
      listName: PropTypes.string.isRequired,
      glAccount: PropTypes.string.isRequired,
      slGlJournalExists: PropTypes.number.isRequired,
    }),
    rowIndex: PropTypes.number.isRequired,
    showGLAccountListModalForAddEdit: PropTypes.func.isRequired,
    showGLAccountListModalForDelete: PropTypes.func.isRequired,
    showAlert: PropTypes.func.isRequired,
  };

  showGLAccountListModalForAddAndEdit = () => {
    const { value, showGLAccountListModalForAddEdit } = this.props;
    return showGLAccountListModalForAddEdit(value);
  };

  showGLAccountListModalForDelete = () => {
    const { value, showGLAccountListModalForDelete, showAlert, rowIndex } = this.props;

    if (value.slGlJournalExists === 1) {
      return showAlert('Selected row cannot be deleted because the List Name-SL Account combination is used in a GL Journal definition for this period.');
    }

    return showGLAccountListModalForDelete({
      entity: value,
      rowIndex,
    });
  };

  render() {
    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit GL Account Settings"
          onClick={this.showGLAccountListModalForAddAndEdit}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>
        <button
          className="cell-icon-button"
          title="Delete GL Account Settings"
          onClick={this.showGLAccountListModalForDelete}
        >
          <TrashIcon size={16} className="cell-icon" />
        </button>
      </div>
    );
  }
}

export default connect(
  null,
  {
    showGLAccountListModalForAddEdit: sharedActions.showModalForAddEdit,
    showGLAccountListModalForDelete: sharedActions.showModalForRemove,
    showAlert: alertNotification,
  }
)(GLAccountListAdminColumnRenderer);
